module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "page-head"
  }, [_vm._t("top"), _vm._v(" "), _vm._c('h2', {
    staticClass: "page-head-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.subtitle) ? _vm._c('p', {
    staticClass: "page-head-description"
  }, [_vm._v(_vm._s(_vm.subtitle))]) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-184b6106!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/PageHeader.vue
// module id = 628
// module chunks = 1